import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ROOT_URL } from "../../api/ApiConfig";
import { buildCreateCannedPayload } from "../../components/dashboardcomponents/SettingsV2/Canned/cannedUtils";

function getAuthToken(getState) {
  const { loginToken, loginTokenCoUser } = getState();
  return loginToken?.response?.token || loginTokenCoUser?.response?.token;
}

export const createCannedMsg = createAsyncThunk(
  "tag/create-canned-message",
  async ({ requestHeaders }, { getState, rejectWithValue }) => {
    const authToken = getAuthToken(getState);
    const body = buildCreateCannedPayload({
      title: requestHeaders.title,
      content: requestHeaders.content,
      shortcut: requestHeaders.shortcut || requestHeaders.tagName,
      businessId: requestHeaders.business_id,
      isPrivate: requestHeaders.is_private,
      groupIds: requestHeaders.groups || requestHeaders.group_ids || [],
    });

    try {
      const response = await fetch(`${ROOT_URL}/tag/create-canned-message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const CreateCannedMsg = createSlice({
  name: "CreateCannedMsg",
  initialState,
  reducers: {},
  extraReducers: {
    [createCannedMsg.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [createCannedMsg.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [createCannedMsg.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default CreateCannedMsg.reducer;
